/* eslint-disable react-hooks/exhaustive-deps */
import { Breadcrumbs } from "../../../AbstractElements";
import { ECommerce, Product } from "../../../Constant";
import { Container } from "reactstrap";
import ProductFeatures from "./ProductFeatures";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import ProductGrid from "./ProductGrid/ProductGrid";
import { useEffect } from "react";
import axios from "axios";
import { ProductsApi } from "../../../api";
import { setProductItem } from "../../../Redux-Toolkit/Reducers/ProductSlice";
import { toast } from "react-toastify";

const ProductContainer = () => {
  const { sideBarOn } = useAppSelector((state) => state.filterData);
  const dispatch = useAppDispatch();

  const fetchProducts = async () => {
    try {
      await axios.get(ProductsApi).then((resp) => {
        dispatch(setProductItem(resp.data));
      });
    } catch (error) {
      toast.error("error"+ error);
    }
  };
  
  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={Product} parent={ECommerce} title={Product} />
      <Container fluid className={`product-wrapper ${sideBarOn ? "sidebaron" : ""}`}>
        <div className="product-grid">
          <ProductFeatures />
          <ProductGrid />
        </div>
      </Container>
    </>
  );
};

export default ProductContainer;
